/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type FetchIssuerMetadataRequestBody = {
  /**
   * Issuer URL to fetch metadata for (e.g. https://login.linear.com).
   */
  issuer: string;
};

/** @internal */
export type FetchIssuerMetadataRequestBody$Outbound = {
  issuer: string;
};

/** @internal */
export const FetchIssuerMetadataRequestBody$outboundSchema: z.ZodMiniType<
  FetchIssuerMetadataRequestBody$Outbound,
  FetchIssuerMetadataRequestBody
> = z.object({
  issuer: z.string(),
});

export function fetchIssuerMetadataRequestBodyToJSON(
  fetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody,
): string {
  return JSON.stringify(
    FetchIssuerMetadataRequestBody$outboundSchema.parse(
      fetchIssuerMetadataRequestBody,
    ),
  );
}
